import Dashboard from "./views/dashboards/default";
import Login from "./views/account/login";
import Register from "./views/account/register";
import ForgotPassword from "./views/account/forgot-password";
import User from "./views/user/user-list";
//import UserView from './views/user/user-edit';
import UserView from "./views/user/user-details";
import ChangePassword from "./views/account/change-password";
import ContentPage from "./views/content-page/list";
import ContentPageAdd from "./views/content-page/add";
import ContentPageEdit from "./views/content-page/edit";
import AdminProfile from "./views/admin/profile";
import VersionList from "./views/version/list";
import VersionAdd from "./views/version/add";
import VersionEdit from "./views/version/edit";

import GeneralList from "./views/general/list";
import GeneralAdd from "./views/general/add";

import BookingDetails from "./views/booking/booking-details";
import ChargingHistoryDetails from "./views/charging-history/charging-history-details";
import WalletHistoryDetails from "./views/wallet-history/wallet-history-details";
import ChargerStatus from "./views/charger-status/charger-status-details";
import PaymentStatus from "./views/payment-status/payment-status-details";
import Reports from "./views/reports/report-details";
import VehicleManagement from "./views/vehicle-management/vehicle-details.vue";
import ChargerManagement from "./views/charger-management/charger-details.vue";
import ChargerAnalytics from "./views/reports/charger-analytics.vue";
import UserReportAnalytics from "./views/reports/user-report-details.vue";
import userAnalytics from "./views/reports/user-analytics.vue";
import walletWithdrawal from "./views/wallet-withdrawal/wallet-withdrawal-details.vue";
import UserReports from "./views/user-reports/user-report-details.vue";
import Banners from "./views/banner/banner-details.vue";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: Dashboard,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: ForgotPassword,
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/user-list",
    name: "user-list",
    meta: {
      authRequired: true,
    },
    component: User,
  },
  {
    path: "/user-view/:id",
    name: "user-view",
    meta: {
      authRequired: true,
    },
    component: UserView,
  },
  {
    path: "/change-password",
    name: "change-password",
    meta: {
      authRequired: true,
    },
    component: ChangePassword,
  },
  {
    path: "/content-page-list",
    name: "content-page-list",
    meta: {
      authRequired: true,
    },
    component: ContentPage,
  },
  {
    path: "/content-page-add",
    name: "content-page-add",
    meta: {
      authRequired: true,
    },
    component: ContentPageAdd,
  },
  {
    path: "/content-page-edit/:id",
    name: "content-page-edit",
    meta: {
      authRequired: true,
    },
    component: ContentPageEdit,
  },
  {
    path: "/admin-profile",
    name: "admin-profile",
    meta: {
      authRequired: true,
    },
    component: AdminProfile,
  },
  {
    path: "/version-list",
    name: "version-list",
    meta: {
      authRequired: true,
    },
    component: VersionList,
  },
  {
    path: "/version-add",
    name: "version-add",
    meta: {
      authRequired: true,
    },
    component: VersionAdd,
  },
  {
    path: "/version-edit/:id",
    name: "version-edit",
    meta: {
      authRequired: true,
    },
    component: VersionEdit,
  },
  {
    path: "/general-list",
    name: "general-list",
    meta: {
      authRequired: true,
    },
    component: GeneralList,
  },
  {
    path: "/general-add",
    name: "general-add",
    meta: {
      authRequired: true,
    },
    component: GeneralAdd,
  },
  {
    path: "/booking-list",
    name: "booking-list",
    meta: {
      authRequired: true,
    },
    component: BookingDetails,
  },
  {
    path: "/charger-history",
    name: "charger-history",
    meta: {
      authRequired: true,
    },
    component: ChargingHistoryDetails,
  },
  {
    path: "/wallet-history",
    name: "wallet-history",
    meta: {
      authRequired: true,
    },
    component: WalletHistoryDetails,
  },
  {
    path: "/charger-status",
    name: "charger-status",
    meta: {
      authRequired: true,
    },
    component: ChargerStatus,
  },
  {
    path: "/payment-status",
    name: "payment-status",
    meta: {
      authRequired: true,
    },
    component: PaymentStatus,
  },
  {
    path: "/reports",
    name: "reports",
    meta: {
      authRequired: true,
    },
    component: Reports,
  },
  {
    path: "/vehicle-details",
    name: "vehicle-details",
    meta: {
      authRequired: true,
    },
    component: VehicleManagement,
  },
  {
    path: "/charger-details",
    name: "charger-details",
    meta: {
      authRequired: true,
    },
    component: ChargerManagement,
  },
  {
    path: "/charger-analytics/:charger_id",
    name: "charger-analytics",
    meta: {
      authRequired: true,
    },
    component: ChargerAnalytics,
  },
  {
    path: "/user-report-details",
    name: "user-report-details",
    meta: {
      authRequired: true,
    },
    component: UserReportAnalytics,
  },
  {
    path: "/user-analytics/:user_id",
    name: "user-analytics",
    meta: {
      authRequired: true,
    },
    component: userAnalytics,
  },
  {
    path: "/withdrawal-details",
    name: "withdrawal-details",
    meta: {
      authRequired: true,
    },
    component: walletWithdrawal,
  },
  {
    path: "/user-report",
    name: "user-report",
    meta: {
      authRequired: true,
    },
    component: UserReports,
  },
  {
    path: "/banner",
    name: "banner",
    meta: {
      authRequired: true,
    },
    component: Banners,
  },
];
